import type { IndividualInvestor } from "@/types";
import { motion } from "framer-motion";
import { useInView } from "@/hooks/reveal-in-view";
import React, { FC, useRef } from "react";

export const InvestorsTags: FC<{
  className?: string;
  investors: IndividualInvestor[];

}> = ({ className, investors }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  const variants = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: (index: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.25,
        ease: "easeOut",
      },
    }),
  };

  return (
    <div
      className={`tags hide-scrollbar ${className ? className : ""}`}
      ref={ref}
    >
      {investors.map((investor, index) => {
        return (
          <a key={index} href={investor.linkedin} target="_blank">
            <motion.div
              className="tags--item"
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              variants={variants}
              custom={index}
              onMouseEnter={(event) => {
                const target = event.currentTarget as HTMLElement;
                target.classList.add("hover-animation-bounce");
              }}
              onAnimationEnd={(event) => {
                const target = event.target as HTMLElement;
                target.classList.remove("hover-animation-bounce");
              }}
            >
              {investor.name}
            </motion.div>
          </a>
        );
      })}
    </div>
  );
};
